/** @jsxImportSource theme-ui @jsxRuntime classic */
import React, { useContext, useEffect } from 'react';
import { Flex, Text, useThemeUI, Button } from '@tishman/components';
import { Close } from '@tishman/icons';
import { navigate } from 'gatsby';
import { getWindow } from '@hzdg/dom-utils';

import {
  Translatable,
  useTranslations,
} from '../../../../utils/use-translations';
import { useLocalizedLink } from '../../../../utils/use-localized-link';
import { CountdownTimerContext } from '../../../../utils/countdown-timer-context-provider';
import { safeDataLayerPush } from '../../utils';

import type { CartTranslations } from '../../../../data/translations/cart';

export const SessionExpiredModal = () => {
  const window = getWindow();
  const { isSessionExpired } = useContext(CountdownTimerContext);
  const getLocalizedLink = useLocalizedLink();
  const { theme } = useThemeUI();
  const translations = useTranslations<CartTranslations>(Translatable.Cart);

  useEffect(() => {
    if (isSessionExpired) {
      safeDataLayerPush({
        event: 'session_time_out',
      });
    }
  }, [isSessionExpired]);

  if (!isSessionExpired) return null;

  return (
    <Flex
      data-close-exit-modal
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        backgroundColor: theme.colors.backgroundOverlay,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Flex
        sx={{
          bg: 'white',
          width: '100%',
          maxWidth: '452px',
          padding: '16px',
        }}
      >
        <Flex
          sx={{
            flex: 1,
            border: '2px solid black',
            flexDirection: 'column',
            rowGap: '24px',
            padding: '16px',
          }}
        >
          <Button
            data-gtm-trigger="close-time-out-window"
            onClick={() => navigate(getLocalizedLink('/buy-tickets'))}
            sx={{
              'width': '48px',
              'height': '48px',
              'p': '16px',
              'alignSelf': 'flex-end',
              'mt': '-16px',
              'mr': '-16px',
              'mb': '-16px',
              '&:hover': {
                bg: 'black',
                svg: {
                  color: 'white',
                },
              },
            }}
          >
            <Close
              sx={{
                color: 'black',
              }}
            />
          </Button>
          <Flex
            sx={{
              flex: 1,
              flexDirection: 'column',
              rowGap: '7px',
            }}
          >
            <Text
              sx={{
                color: 'black',
                textAlign: 'center',
                fontSize: '21px',
                fontWeight: 400,
                lineHeight: 1.16,
              }}
            >
              {translations?.sessionTimeoutHeader}
            </Text>
            <Text sx={{ textAlign: 'center', color: 'black' }} variant="smallP">
              {translations?.sessionTimeoutText}
            </Text>
          </Flex>

          <Button
            onClick={() => navigate(getLocalizedLink('/buy-tickets'))}
            sx={{
              bg: 'textInverted',
              border: 'none',
              fontSize: '14px',
              fontWeight: 'medium',
              lineHeight: 1,
              letterSpacing: '2px',
              height: '58px',
              py: 21,
            }}
          >
            {translations?.sessionTimeoutButtonText}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
